export default function validateRePassword(password, rePassword) {
  let message = '';
  let success = false;

  if (!rePassword) {
    message = '비밀번호를 다시 한번 더 입력해 주세요.';
  } else if (rePassword !== password) {
    message = '비밀번호가 같지 않습니다.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
